enum ScreenWidth {
  MOBILE = 450,
  SCREEN_MD = 685
}

export default ScreenWidth;
